/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/link/link.component.ngfactory';
import * as import2 from '../../buttons/link/link.component';
import * as import3 from 'ng2-translate/src/translate.pipe';
import * as import4 from 'ng2-translate/src/translate.service';
import * as import5 from '@angular/common';
import * as import6 from './order-heading-panel.component';
import * as import7 from '../../ordering-context/ordering-context.model';
import * as import8 from '../../orchestration/navigation.service';
const styles_OrderHeadingPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderHeadingPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderHeadingPanelComponent,
  data: {}
}
);
function View_OrderHeadingPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'order-heading-notes'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.editNotes()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_LinkComponent_0,import1.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.orderingContextModel.customerNotes? 'woa.button.order.notes.edit': 'woa.button.order.notes.add');
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_OrderHeadingPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-heading-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderHeadingPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.OrderHeadingPanelComponent = v.component;
    const currVal_1:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform(co.SessionEvents.currentApp$)).showNotes;
    ck(v,5,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.heading.order.summary.order'));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderHeadingPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-heading-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderHeadingPanelComponent_0,RenderType_OrderHeadingPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import6.OrderHeadingPanelComponent,[
      import7.OrderingContextModel,
      import8.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderHeadingPanelComponentNgFactory:import0.ComponentFactory<import6.OrderHeadingPanelComponent> = import0.ɵccf('woa-order-heading-panel',import6.OrderHeadingPanelComponent,View_OrderHeadingPanelComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctcGFnZS9vcmRlci1oZWFkaW5nLXBhbmVsL29yZGVyLWhlYWRpbmctcGFuZWwuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctcGFnZS9vcmRlci1oZWFkaW5nLXBhbmVsL29yZGVyLWhlYWRpbmctcGFuZWwuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9vcmRlcmluZy1wYWdlL29yZGVyLWhlYWRpbmctcGFuZWwvb3JkZXItaGVhZGluZy1wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctcGFnZS9vcmRlci1oZWFkaW5nLXBhbmVsL29yZGVyLWhlYWRpbmctcGFuZWwuY29tcG9uZW50LnRzLk9yZGVySGVhZGluZ1BhbmVsQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIm9yZGVyLWhlYWRpbmctdGl0bGVcIj5cbiAgICB7eyd3b2EuaGVhZGluZy5vcmRlci5zdW1tYXJ5Lm9yZGVyJyB8IHRyYW5zbGF0ZX19XG48L2Rpdj5cbjx3b2EtbGluayAqbmdJZj1cIihTZXNzaW9uRXZlbnRzLmN1cnJlbnRBcHAkIHwgYXN5bmMpLnNob3dOb3Rlc1wiIGNsYXNzPVwib3JkZXItaGVhZGluZy1ub3Rlc1wiXG4gICAgICAgICAgW2xpbmtdPVwiKG9yZGVyaW5nQ29udGV4dE1vZGVsLmN1c3RvbWVyTm90ZXMgPyAnd29hLmJ1dHRvbi5vcmRlci5ub3Rlcy5lZGl0JyA6ICd3b2EuYnV0dG9uLm9yZGVyLm5vdGVzLmFkZCcpXCJcbiAgICAgICAgICAob25BY3RpdmF0ZSk9XCJlZGl0Tm90ZXMoKVwiPjwvd29hLWxpbms+XG4iLCI8d29hLW9yZGVyLWhlYWRpbmctcGFuZWw+PC93b2Etb3JkZXItaGVhZGluZy1wYW5lbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0dBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFFVTtRQUFBO1FBQUE7TUFBQTtNQUZWO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUNVO0lBRFYsU0FDVSxTQURWOzs7OztNQUhBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUM7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTs7O0lBQUE7SUFBQTtJQUUzQjtJQUNOO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQVU7SUFFc0M7Ozs7SUFGdEM7SUFBVixTQUFVLFNBQVY7O0lBSGlDO0lBQUE7Ozs7O0lDQWpDO2dCQUFBOzs7SUFBQTtLQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ordering-page/order-heading-panel/order-heading-panel.component.ngfactory.ts